/* ================================================================
   HOA UGC VIDEOS — hoa-ugc-videos.js
   IntersectionObserver für Autoplay/Pause, Sound-Toggle,
   Lazy-Loading. Kein externes Framework.
   ================================================================ */
(function () {
  'use strict';

  /* Reduced-Motion: Videos komplett pausiert lassen */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Alle Video-Cards einsammeln ──────────────────────────── */
  var items  = Array.from(document.querySelectorAll('.hoa-ugc__item'));
  var videos = items.map(function (item) {
    return item.querySelector('.hoa-ugc__video');
  }).filter(Boolean);

  if (!videos.length) return;

  /* ── IntersectionObserver für Autoplay / Pause ────────────── */
  if (window.IntersectionObserver) {
    var playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (prefersReducedMotion) return;

        if (entry.isIntersecting) {
          /* Lazy-Load: src aus data-src setzen falls noch nicht geladen */
          if (video.getAttribute('data-src') && !video.src) {
            video.src = video.getAttribute('data-src');
          }
          video.play().catch(function () {});
          video.closest('.hoa-ugc__item').classList.add('hoa-ugc--playing');
        } else {
          video.pause();
        }
      });
    }, {
      threshold: 0.4  /* Video muss mind. 40% sichtbar sein */
    });

    videos.forEach(function (video) { playObserver.observe(video); });
  }

  /* ── Lazy-Loading: erste 3 sofort, Rest on-demand ─────────── */
  videos.forEach(function (video, idx) {
    if (idx < 3) {
      /* Direkt laden */
      if (video.getAttribute('data-src')) {
        video.src = video.getAttribute('data-src');
      }
    }
    /* idx >= 3 wird durch IntersectionObserver geladen */
  });

  /* ── Keyboard-Accessibility: Video pausiert bei Fokus ─────── */
  items.forEach(function (item) {
    item.addEventListener('focusin', function () {
      var video = item.querySelector('.hoa-ugc__video');
      if (video) video.pause();
    });
    item.addEventListener('focusout', function () {
      var video = item.querySelector('.hoa-ugc__video');
      if (video && !prefersReducedMotion) video.play().catch(function () {});
    });
  });

  /* ── Sound-Toggle ─────────────────────────────────────────── */
  document.querySelectorAll('.hoa-ugc__sound').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var item  = btn.closest('.hoa-ugc__item');
      var video = item.querySelector('.hoa-ugc__video');
      if (!video) return;

      var willUnmute = video.muted;

      if (willUnmute) {
        /* Alle anderen Videos muten */
        videos.forEach(function (v) {
          if (v !== video) {
            v.muted = true;
            updateSoundBtn(v.closest('.hoa-ugc__item'));
          }
        });
        video.muted = false;
      } else {
        video.muted = true;
      }

      updateSoundBtn(item);
    });
  });

  function updateSoundBtn(item) {
    if (!item) return;
    var video = item.querySelector('.hoa-ugc__video');
    var btn   = item.querySelector('.hoa-ugc__sound');
    if (!video || !btn) return;

    var isMuted = video.muted;
    btn.setAttribute('aria-label', isMuted ? 'Ton einschalten' : 'Ton ausschalten');
    var icon = btn.querySelector('.hoa-ugc__sound-icon');
    if (icon) icon.textContent = isMuted ? '🔇' : '🔊';
  }

  /* ── Mobile Scroll-Dots ───────────────────────────────────── */
  var grid = document.querySelector('.hoa-ugc__grid');
  var dotsContainer = document.querySelector('.hoa-ugc__dots');

  if (grid && dotsContainer && items.length > 1) {
    /* Dots erzeugen */
    items.forEach(function (item, idx) {
      var dot = document.createElement('button');
      dot.className = 'hoa-ugc__dot' + (idx === 0 ? ' hoa-ugc__dot--active' : '');
      dot.setAttribute('aria-label', 'Video ' + (idx + 1) + ' anzeigen');
      dot.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dotsContainer.appendChild(dot);
    });

    /* Scroll → aktiven Dot aktualisieren */
    var dots = Array.from(dotsContainer.querySelectorAll('.hoa-ugc__dot'));
    var scrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = items.indexOf(entry.target);
        if (idx === -1) return;
        dots.forEach(function (d, i) {
          d.classList.toggle('hoa-ugc__dot--active', i === idx);
        });
      });
    }, {
      root: grid,
      threshold: 0.6
    });
    items.forEach(function (item) { scrollObserver.observe(item); });
  }

}());
